// UI 文言（既定ロケール zh-TW）。画面に出る文字列はすべてここに集約する。
// 日本語・英語を UI に混在させない（CLAUDE.md ★言語方針）。

export const t = {
  appTitle: "合約管理系統",
  appSubtitle: "台北支社",

  nav: {
    list: "合約一覧",
    new: "新增登記",
    audit: "稽核紀錄",
  },

  audit: {
    title: "稽核紀錄",
    subtitle: "（記錄不可竄改，僅供事務局與總經理檢視）",
    filterAction: "操作類別",
    empty: "目前沒有符合條件的紀錄。",
    columnTime: "時間",
    columnActor: "操作者",
    columnAction: "操作",
    columnTarget: "對象",
    columnDetail: "細節",
    contractRef: "合約 #",
  },

  common: {
    save: "儲存",
    saveDraft: "儲存草稿",
    submit: "送出登記",
    resubmit: "重新送出",
    cancel: "取消",
    close: "關閉",
    edit: "編輯",
    approve: "核准",
    reject: "退回",
    confirm: "確認",
    loading: "載入中…",
    saving: "處理中…",
    required: "必填",
    optional: "選填",
    yes: "是",
    no: "否",
    none: "無",
    back: "返回",
  },

  fields: {
    contractName: "合約名稱",
    counterparty: "對方",
    contractType: "合約類型",
    continuity: "持續性",
    amount: "金額",
    currency: "幣別",
    amountType: "金額類別",
    period: "合約期間",
    periodStart: "開始日",
    periodEnd: "結束日",
    specialClauses: "特殊條款",
    nextRenewalDate: "下次續約日",
    department: "部門",
    createdBy: "登記人",
    status: "狀態",
    updatedAt: "最後更新",
  },

  placeholders: {
    contractName: "請輸入合約名稱",
    counterparty: "請輸入對方名稱",
    amount: "請輸入金額",
    select: "請選擇",
    rejectReason: "請說明退回理由（必填）",
  },

  list: {
    title: "合約一覧",
    empty: "目前沒有符合條件的合約。",
    newButton: "新增登記",
    columnName: "合約名稱",
    columnCounterparty: "對方",
    columnType: "類型",
    columnAmount: "金額",
    columnDept: "部門",
    columnStatus: "狀態",
  },

  form: {
    newTitle: "新增合約登記",
    editTitle: "編輯合約登記",
    factSectionTitle: "事實欄位",
    factSectionHint: "請填寫您所掌握的事實。損益與風險評估由經營層負責，承辦人無須填寫。",
    autoRenewLinked: "已自動勾選「自動續約」特殊條款。",
  },

  detail: {
    title: "合約明細",
    rejectionReasonTitle: "退回理由",
    factSection: "事實欄位",
    evaluationSection: "經營層評估",
    evaluationPending: "尚未評估。",
    commentsSection: "留言記錄",
  },

  approval: {
    rejectTitle: "退回此合約",
    rejectReasonLabel: "退回理由",
    rejectReasonRequired: "退回時必須填寫理由。",
    approveConfirm: "確定要核准此合約嗎？核准後將進入會議提報。",
  },

  evaluation: {
    plImpact: "損益影響",
    plImpactNote: "補充說明",
    riskLevel: "風險評估",
    classification: "分類",
    hqReviewStatus: "總公司確認狀態",
    editButton: "填寫評估",
    save: "儲存評估",
    saved: "評估已儲存。",
    hqOnlyForC: "（僅 C類需要填寫總公司確認狀態）",
    notClassified: "尚未分類",
  },

  comments: {
    meetingMemoTitle: "會議備忘（僅經營層可見）",
    staffContactTitle: "與承辦人的聯絡（承辦人亦可見）",
    meetingMemoHint: "此欄僅事務局與總經理可見，承辦人看不到。",
    staffContactHint: "此欄承辦人也看得到，請以可對外傳達的措辭撰寫。",
    placeholder: "輸入留言…",
    postButton: "送出留言",
    empty: "目前沒有留言。",
  },

  hqReview: {
    title: "總公司確認進度",
    staffNote: "進度將由事務局（駐日代表）以文字說明，請留意「與承辦人的聯絡」欄。",
  },

  attachments: {
    title: "附件（合約書等）",
    note: "※ 系統附件為「參考用副本」，正本請依既有方式保管（紙本／既有儲存）。最新內容請以正本為準。",
    upload: "上傳檔案",
    uploading: "上傳中…",
    empty: "目前沒有附件。",
    download: "下載",
    delete: "刪除",
    deleteConfirm: "確定要刪除此附件嗎？",
    notConfigured: "附件功能尚未設定（需綁定 R2）。",
  },

  flow: {
    title: "締約進行中（全公司）",
    filterStatus: "狀態",
    filterClassification: "分類",
    all: "全部",
    unclassified: "未分類",
    columnStage: "進行階段",
    columnClassification: "分類",
    columnHq: "總公司確認",
  },

  ledger: {
    title: "合約台帳（風險盤點）",
    toggleFlow: "締約進行中",
    toggleLedger: "合約台帳",
    empty: "目前沒有需要特別留意的合約。",
    lensAll: "全部風險",
    lensExpiring: "滿期接近",
    lensAutoRenew: "自動續約",
    lensSpecial: "特殊條款",
    lensLarge: "大額",
    thresholdNote: "※ 風險門檻（滿期 90 天內、大額金額）為暫定值，可於營運中調整。",
    columnRisk: "風險標記",
    columnKeyDate: "關鍵日期",
    keyDateExpiry: "到期",
    keyDateRenewal: "續約",
    expired: "已逾期",
  },

  dev: {
    bannerLabel: "開發模式｜切換身分：",
    note: "（此切換僅在開發／預覽環境顯示，正式環境會以 Microsoft 365 登入。）",
  },

  errors: {
    loadFailed: "載入失敗，請稍後再試。",
    saveFailed: "儲存失敗。",
    notLoggedIn: "尚未登入或無法辨識身分。",
  },
} as const;
